




















































import qs from "qs";
import Vue from "vue";

export default Vue.extend({
  name: "Login",
  data: () => ({
    valid: false,
    show: false,
    username: "",
    password: "",
    userRules: [(v: String) => !!v || "Bitte Benutzername eingeben"],
    passwordRules: [(v: String) => !!v || "Bitte Passwort eingeben"],
    error: false
  }),
  methods: {
    login(): void {
      const data = qs.stringify({
        _username: this.username,
        _password: this.password
      });
      this.$auth.login({
        data,
        success: () => {
          this.error = true;
          const redirect = this.$auth.redirect();
          let path = redirect ? redirect.from.path : "/";
          this.$router.push(path);
        },
        error: ({ message }: { message: string }) => {
          if (message.includes("401")) this.error = true;
        }
      });
    }
  }
});
